module.exports = __webpack_public_path__ + "media/icon-rede-vistorias-white.9c609110.png";